import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Start from './pages/Start';
import AppContext from './context/AppContext';
import Createquiz from './pages/Createquiz';
import Result from './pages/Result';
import Enterquiz from './pages/Enterquiz';
import Playername from './pages/Playername';
import Exam from './pages/Exam';
import Score from './pages/Score';

function App() {
  return (
    <>
      <AppContext>
        <Navbar />
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/start' element={<Start />} />
          <Route exact path='/create-quiz' element={<Createquiz />} />
          <Route exact path='/result' element={<Result />} />
          <Route exact path='/quiz/:userid/:name' element={<Enterquiz />} />
          <Route exact path='/playername' element={<Playername />} />
          <Route exact path='/exam' element={<Exam />} />
          <Route exact path='/score' element={<Score />} />
        </Routes>
      </AppContext>
    </>
  );
}

export default App;
